import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as ReactRouter from 'react-router';
import {IndexRoute, Route, Router} from 'react-router';
import Minilog from 'minilog';
import Promise from 'bluebird';

import {forEach} from './model/core/objects';
import {appRoutes} from './model/routes/main';
import {PremisesListing} from './components/premises';
import {CabinetDetailsConnected} from './components/cabinetdetails';
import {PremisesRegistration} from './components/registration';
import {CalibrationConnected} from './components/calibration';
import {SettingsPage} from './components/settings';
import {PasswordPage} from './components/password';
import {CabinetList} from './components/cabinetlist';
import {ReduxRoot} from './components/redux';
import {
    onPremisesLoad, onCabinetLoad, onRegistrationLoad, onCalibrationLoad
} from './model/routes/loaders';
import {GlobalHistory, GlobalStore} from './model/redux/store';

// generate Routes for all defined application routes
let routeHandlers = {
    premises: PremisesListing
};

function onEnterWrap(onEnter) {
    return function (state: ReactRouter.RouterState) {
        onEnter(GlobalStore, state.params, state.location.query);
    };
}

let routes = forEach(appRoutes, function(key, appRoute) {
    let handler = routeHandlers[key];
    let route;
    let onEnter = onEnterWrap(appRoute.onLoad);
    if (handler) {
        route = <Route key={key} path={appRoute.path}
                       component={handler} onEnter={onEnter} />;
    } else {
        route = <Route key={key} path={appRoute.path} onEnter={onEnter} />;
    }
    return route;
});

let baseRoute: any = (<Router history={GlobalHistory}>
        <Route path="/" component={ReduxRoot}>
            <IndexRoute component={PremisesListing} onEnter={onEnterWrap(onPremisesLoad)} />
            <Route path="stores" component={PremisesListing} onEnter={onEnterWrap(onPremisesLoad)} />
            <Route path="cabinet-details/:unitId" component={CabinetDetailsConnected}/>
            <Route path="premises/register(/:gatewayId)" component={PremisesRegistration} onEnter={onEnterWrap(onRegistrationLoad)} />
            <Route path="calibration" component={CalibrationConnected} onEnter={onEnterWrap(onCalibrationLoad)} />
            <Route path="account/settings" component={SettingsPage} />
            <Route path="account/password" component={PasswordPage} />
            <Route path="cabinets" component={CabinetList} onEnter={onEnterWrap(onCabinetLoad)} />
            {routes}
        </Route>
    </Router>);

ReactDOM.render(baseRoute, document.body);

Minilog.suggest.clear().allow('.*');
Minilog.enable();

Promise.config({
    cancellation: true
});
